import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserPlus, Loader2, Eye, EyeOff } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AcceptInvitePage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({ password: '', confirm: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (form.password !== form.confirm) { toast.error('Passwords do not match'); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API}/users/accept-invite`, { token, password: form.password });
      localStorage.setItem('auth_token', res.data.token);
      localStorage.setItem('auth_user', JSON.stringify(res.data.user));
      localStorage.setItem('tenant_id', res.data.user.tenant_id);
      toast.success('Account created! Welcome aboard.');
      navigate('/dashboard');
    } catch (error) { toast.error(error.response?.data?.detail || 'Failed to accept invite'); }
    finally { setLoading(false); }
  };

  return (
    <div className="auth-page" data-testid="accept-invite-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon">D</div>
          <h1>DepinaCRM</h1>
        </div>
        <h2>Accept Invitation</h2>
        <p className="auth-subtitle">Set up your password to join your team.</p>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label>Create Password</label>
            <div className="password-field">
              <input type={showPassword ? 'text' : 'password'} value={form.password}
                onChange={(e) => setForm(p => ({ ...p, password: e.target.value }))}
                placeholder="Min 6 characters" data-testid="invite-password" />
              <button type="button" className="toggle-pw" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <div className="auth-field">
            <label>Confirm Password</label>
            <input type="password" value={form.confirm}
              onChange={(e) => setForm(p => ({ ...p, confirm: e.target.value }))}
              placeholder="Confirm password" data-testid="invite-confirm" />
          </div>
          <button type="submit" className="auth-submit" disabled={loading} data-testid="invite-submit">
            {loading ? <Loader2 className="animate-spin" size={18} /> : <UserPlus size={18} />}
            {loading ? 'Creating account...' : 'Accept & Join'}
          </button>
        </form>
      </div>
    </div>
  );
}
